export const getters = {
  getPerformanceFilters(state) {
    return state.performanceFilters;
  },

  getSearchOptions(state) {
    return state.searchOptions;
  },

  getSearchPcpOptions(state) {
    return state.searchPcpOptions;
  },

  getAlertFilters(state) {
    return state.alertFilters;
  },

  getMatrixFilters(state) {
    return state.matrixFilters;
  },

  getBroilerFilters(state) {
    return state.broilerFilters;
  },

  getLayingBirdsFilters(state) {
    return state.layingBirdsFilters;
  },

  getSwineFilters(state) {
    return state.swineFilters;
  },

  getSlaughterPredictionFilters(state) {
    return state.slaughterPredictionFilters;
  },

  getSanityFilters(state) {
    return state.sanityFilters;
  },

  getPcpFilters(state) {
    return state.pcpFilters;
  },

  getPcpPlanningFilters(state) {
    return state.pcpPlanningFilters;
  },

  getNutritionFilters(state) {
    return state.nutritionFilters;
  },

  getParams(state) {
    return state.params;
  },

  getConfiguredFilters(state) {
    return state.configuredFilters;
  },

  getPcpConfiguredFilters(state) {
    return state.pcpConfiguredFilters;
  },

  getPcpPlanningConfiguredFilters(state) {
    return state.configuredFilters;
  },

  getAlertsHistoryFilters(state) {
    return state.alertsHistoryFilters;
  },

  getIndexFilter(state) {
    return state.indexFilter;
  },

  getPcpIndexFilter(state) {
    return state.pcpIndexFilter;
  },

  getShowDisabledProperties(state) {
    return state.showDisabledProperties;
  },

  getShowSlaughterState(state) {
    return state.showSlaughterState;
  },

  getShowLodgeState(state) {
    return state.showLodgeState;
  },

  getShowPreLodgeState(state) {
    return state.showPreLodgeState;
  },

  getRequestParams(state) {
    return state.requestParams;
  },

  getFlagSlaughterPrediction(state) {
    return state.flagSlaughterPrediction;
  },

  getSearchSlaughterPrediction(state) {
    return state.searchSlaughterPrediction;
  },

  getFlagPcpPrediction(state) {
    return state.flagPcpPrediction;
  },

  getFlagPcpSimulation(state) {
    return state.flagPcpSimulation;
  },

  getSearchPcpPrediction(state) {
    return state.searchPcpPrediction;
  },

  getCategory(state) {
    return state.category;
  }
};
